'use client';
import QueryKey from '../utils/queryKeys';
import { useQuery } from '@tanstack/react-query';
import { DEFAULT_SHINKAI_NAMESPACE } from '../utils/constants';
import { useAccountChainIdOrDefault } from './useAccountChainIdOrDefault';

export const useGetDefaultShinkaiNamespace = () => {
  const chainId = useAccountChainIdOrDefault();

  return useQuery({
    queryKey: [QueryKey.DEFAULT_SHINKAI_NAMESPACE, { chainId }],
    queryFn: () => DEFAULT_SHINKAI_NAMESPACE[chainId],
    initialData: '',
  });
};
